
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Count extends Vue {
    @Prop({ type: Number, default: 0 }) total!: number;
    @Prop({ type: Boolean, default: false }) loading!: boolean;
}
